/**
 * Every choice the site holds on to, in one place.
 *
 * Nothing survives closing the tab: visitor selections live in sessionStorage, so every visit opens clean.
 * "Start again" clears them mid-visit, from both storages, so a browser that kept something from an earlier
 * build is cleaned out too. The admin sign-in token is deliberately left alone — it is not a selection, and a
 * visitor clearing their choices must not sign an administrator out.
 */
const VISITOR_KEYS = ["kskf-lease-saved", "kskf-role", "kskf-intro-seen", "kskf-shortlist", "kskf-facility",
  "kskf-faceoff-saved"];
const KEEP = ["kskf_token"];

const stores = () => {
  const list = [];
  try { if (window.sessionStorage) list.push(window.sessionStorage); } catch { /* blocked */ }
  try { if (window.localStorage) list.push(window.localStorage); } catch { /* blocked */ }
  return list;
};

/** Read a remembered selection. Session-scoped, so it is gone on the next visit. */
export const readSelection = (key, fallback = null) => {
  try {
    const raw = window.sessionStorage.getItem(key);
    return raw === null ? fallback : JSON.parse(raw);
  } catch {
    return fallback;
  }
};

export const writeSelection = (key, value) => {
  try {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  } catch { /* private mode: the selection simply is not remembered */ }
};

/** Wipe every visitor selection, in every storage. Leaves the admin token in place. */
export const clearSelections = () => {
  stores().forEach((store) => {
    try {
      const keys = new Set([...VISITOR_KEYS, ...Object.keys(store).filter((k) => k.startsWith("kskf-"))]);
      keys.forEach((k) => { if (!KEEP.includes(k)) store.removeItem(k); });
    } catch { /* ignore */ }
  });
};

export const SELECTION_KEYS = VISITOR_KEYS;
